import { CSSProperties } from "react";

const style: {
  cell: CSSProperties;
  icon: CSSProperties;
} = {
  cell: {
    padding: 9,
    width: "100%",
  },
  icon: { marginTop: 5 },
};

export default style;
